import { createSlice } from "@reduxjs/toolkit";
import {
  assignStoreManager,
  confirmDelivery,
  createOrderNotes,
  dispatchOrder,
  getAnOrder,
  getOrderNote,
  getOrders,
  getOrdersStats,
  getOrderTimeline,
  getOverdueOrders,
  getRefunds,
  getStockValues,
  getVendorPayment,
  getVendorPaymentInfo,
  getVendorsStats,
  refundsApproval,
  refundsInfo,
  searchOrders,
  vendorDetails,
  vendorOrders,
} from "./ordersAction";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const initialState = {
  // GET ALL ORDERS
  ordersData: [],
  ordersTotal: 0,
  ordersLoading: false,

  // GET AN ORDER
  orderData: {},
  orderLoading: false,

  // get an order notes
  orderNotes: [],
  orderNotesLoading: false,

  total_stock: 0,
  storeManagers: [],

  // GET OVERDUE ORDERs
  overdueOrderData: [],
  overdueOrderLoading: false,
  overdueOrderTotal: 0,
  

  // GET ORDER TIMELINE
  orderTimelineData: {},
  orderTimelineLoading: false,

  // GET ORDERS STATS
  ordersStatsData: {},

  // GET VENDOR PAYMENt
  vendorPaymentData: [],
  vendorPaymentLoading: false,
  vendorPaymentTotal: 0,

  // GET VENDOR PAYMENt INFO
  vendorPaymentInfoData: {},
  vendorPaymentInfoLoading: false,

  // GET REFUNDS
  refundsData: [],
  refundsLoading: false,
  refundsTotal: 0,

  // GET REFUNDS INFO
  refundsInfoData: {},
  refundsInfoLoading: false,

  // GET REFUNDS INFO

  refundsApprovalLoading: false,

  // GET VENDOR STATS
  vendorStatsData: [],
  vendorStatsLoading: false,
  vendorStatsTotal: 0,

  vendorDetailsData: {},
  vendorDetailsLoading: false,

  vendorOrdersData: [],
  vendorOrdersLoading: false,
  vendorOrdersTotal: 0,
};

const ordersPersistConfig = {
  key: "orders",
  storage,
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
  },
  extraReducers: {
    [getOrders.pending]: (state) => {
      state.ordersLoading = true;
    },
    [getOrders.fulfilled]: (state, { payload }) => {
      state.ordersLoading = false;
      state.ordersData = payload.data;
      state.ordersTotal = payload.total ? payload.total : payload.data.length;
    },
    [getOrders.rejected]: (state) => {
      state.ordersLoading = false;
    },

    //GET AN ORDER
    [getAnOrder.pending]: (state) => {
      state.orderLoading = true;
    },
    [getAnOrder.fulfilled]: (state, { payload }) => {
      state.orderLoading = false;
      state.orderData = payload?.data ?? [];
    },
    [getAnOrder.rejected]: (state) => {
      state.orderLoading = false;
    },

    // Get an order notes
    [getOrderNote.pending]: (state) => {
      state.orderNotesLoading = true
    },
    [getOrderNote.fulfilled]: (state, { payload }) => {
      state.orderNotesLoading = false;
      state.orderNotes = payload?.data ?? {};
    },
    [getOrderNote.rejected]: (state) => {
      state.orderNotesLoading = false
    },

    // create order note
     [createOrderNotes.pending]: (state) => {
     },
     [createOrderNotes.fulfilled]: (state, { payload }) => {

     },
     [createOrderNotes.rejected]: (state) => {
     }, 

       // get stock values
     [getStockValues.pending]: (state) => {
     },
     [getStockValues.fulfilled]: (state, { payload }) => {
        state.total_stock = payload?.data?.total_stock ?? 0
        state.storeManagers = payload?.data?.locations ?? []
     },
     [getStockValues.rejected]: (state) => {
     }, 

       // assign store manager 
     [assignStoreManager.pending]: (state) => {
     },
     [assignStoreManager.fulfilled]: (state, { payload }) => {

     },
     [assignStoreManager.rejected]: (state) => {
     }, 

         // dispatch an order
     [dispatchOrder.pending]: (state) => {
     },
     [dispatchOrder.fulfilled]: (state, { payload }) => {

     },
     [dispatchOrder.rejected]: (state) => {
     }, 

         // confirm delivery an order
     [confirmDelivery.pending]: (state) => {
     },
     [confirmDelivery.fulfilled]: (state, { payload }) => {

     },
     [confirmDelivery.rejected]: (state) => {
     }, 

    // SEARCH FOR ORDERS
    [searchOrders.pending]: (state) => {
      state.ordersLoading = true;
    },
    [searchOrders.fulfilled]: (state, { payload }) => {
      state.ordersLoading = false;
      state.ordersData = payload.data;
      state.ordersTotal = payload.total;
    },
    [searchOrders.rejected]: (state) => {
      state.ordersLoading = false;
    },

    //GET ORDER TIMELINE
    [getOrderTimeline.pending]: (state) => {
      state.orderTimelineLoading = true;
    },
    [getOrderTimeline.fulfilled]: (state, { payload }) => {
      state.orderTimelineLoading = false;
      state.orderTimelineData = payload?.data ?? {};
    },
    [getOrderTimeline.rejected]: (state) => {
      state.orderTimelineLoading = false;
    },

    // GET OVERDUE ORDERS
    [getOverdueOrders.pending]: (state) => {
      state.overdueOrderLoading = true;
    },
    [getOverdueOrders.fulfilled]: (state, { payload }) => {
      state.overdueOrderLoading = false;
      state.overdueOrderData = payload.data;
      state.overdueOrderTotal = payload.count;
    },
    [getOverdueOrders.rejected]: (state) => {
      state.overdueOrderLoading = false;
    },

    // GET ORDERS STATS
    [getOrdersStats.pending]: (state) => {
      state.orderLoading = true;
    },
    [getOrdersStats.fulfilled]: (state, { payload }) => {
      state.orderLoading = false;
      state.ordersStatsData = payload;
    },
    [getOrdersStats.rejected]: (state) => {
      state.orderLoading = false;
    },

    // GET VENDOR PAYMENT
    [getVendorPayment.pending]: (state) => {
      state.vendorPaymentLoading = true;
    },
    [getVendorPayment.fulfilled]: (state, { payload }) => {
      state.vendorPaymentLoading = false;
      state.vendorPaymentData = payload.data;
      state.vendorPaymentTotal = payload.count;
    },
    [getVendorPayment.rejected]: (state) => {
      state.vendorPaymentLoading = false;
    },

    // GET VENDOR PAYMENT INFO
    [getVendorPaymentInfo.pending]: (state) => {
      state.vendorPaymentInfoLoading = true;
    },
    [getVendorPaymentInfo.fulfilled]: (state, { payload }) => {
      state.vendorPaymentInfoLoading = false;
      state.vendorPaymentInfoData = payload.data;
    },
    [getVendorPaymentInfo.rejected]: (state) => {
      state.vendorPaymentInfoLoading = false;
    },

    // GET REFUNDS
    [getRefunds.pending]: (state) => {
      state.refundsLoading = true;
    },
    [getRefunds.fulfilled]: (state, { payload }) => {
      state.refundsLoading = false;
      state.refundsData = payload.data;
      state.refundsTotal = payload.count;
    },
    [getRefunds.rejected]: (state) => {
      state.refundsLoading = false;
    },

    // GET REFUNDS INFO
    [refundsInfo.pending]: (state) => {
      state.refundsInfoLoading = true;
    },
    [refundsInfo.fulfilled]: (state, { payload }) => {
      state.refundsInfoLoading = false;
      state.refundsInfoData = payload;
    },
    [refundsInfo.rejected]: (state) => {
      state.refundsInfoLoading = false;
    },

    // REFUNDS APPROVAL
    [refundsApproval.pending]: (state) => {
      state.refundsApprovalLoading = true;
    },
    [refundsApproval.fulfilled]: (state, { payload }) => {
      state.refundsApprovalLoading = false;
    },
    [refundsApproval.rejected]: (state) => {
      state.refundsApprovalLoading = false;
    },

    // VENDOR STATS
    [getVendorsStats.pending]: (state) => {
      state.vendorStatsLoading = true;
    },
    [getVendorsStats.fulfilled]: (state, { payload }) => {
      state.vendorStatsLoading = false;
      state.vendorStatsData = payload.results;
      state.vendorStatsTotal = payload.count;
    },
    [getVendorsStats.rejected]: (state) => {
      state.vendorStatsLoading = false;
    },

    [vendorDetails.pending]: (state) => {
      state.vendorDetailsLoading = true;
    },
    [vendorDetails.fulfilled]: (state, { payload }) => {
      state.vendorDetailsLoading = false;
      state.vendorDetailsData = payload.data;
    },
    [vendorDetails.rejected]: (state) => {
      state.vendorDetailsLoading = false;
    },

    [vendorOrders.pending]: (state) => {
      state.vendorOrdersLoading = true;
    },
    [vendorOrders.fulfilled]: (state, { payload }) => {
      state.vendorOrdersLoading = false;
      state.vendorOrdersData = payload.data;
      state.vendorOrdersTotal = payload.total;
    },
    [vendorOrders.rejected]: (state) => {
      state.vendorOrdersLoading = false;
    },
  },
});

const ordersReducer = persistReducer(ordersPersistConfig, ordersSlice.reducer);

// Action creators are generated for each case reducer function
export const { increment, decrement } = ordersSlice.actions;

export default ordersReducer;
